import { initialsFormatter } from '@asn/formatters';

import { AfterViewInit, Component, input, ViewEncapsulation, inject } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApInputConstraintService } from '@ap/input/constraint';
import { ApContentService } from '@ap/content';
import { AbstractInputComponent, ApAutocompleteFilterService, ApAutocompleteModule } from '@ap/input';
import { ApInitialsValidator } from '@ap/input/validators';
import { ApSuggestionComponent } from '@ap/input/suggestion';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApIconComponent } from '@ap/icon';

import content from './initials-input.content.json';

@Component({
    selector: 'ap-initials-input',
    templateUrl: '../../../src/lib/input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApIconComponent, ApSuggestionComponent, ApFormErrorsComponent, ApAutocompleteModule, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApInitialsInputComponent extends AbstractInputComponent implements AfterViewInit {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Characters that are stripped
     */
    protected readonly stripPattern = input<RegExp>(/[^a-z.\s]/gi);

    constructor() {
        super();
        this.setDefaultContent(content, 'initials-input');
    }

    /**
     * After init bind the control validation
     */
    public ngAfterViewInit(): void {
        const control = this.control?.control;
        if (control) {
            control.addValidators([ApInitialsValidator.validate]);
            control.updateValueAndValidity();
        }
    }

    /**
     * Format value as initials.
     * Called on blur of input
     */
    protected formatValue(value: string): string {
        return initialsFormatter.format(value);
    }
}
